// 商品库编辑操作
import Api from '@/script/api';
import lodash from 'lodash';
import Message from '@/script/Message'

const state = {
    editProduct: null,      //当前编辑的商品
    loading: false,         //加载状态
    // 图片选择操作
    imageSelect: {
        show: false,        // 是否显示图片选择
        field: "",          // 当前选择的字段（用于上传张数限制）
        _resolve: null,     // 图片选择成功回调
        _reject: null,      // 图片选择失败回调
    },
    isLockCate: false,      // 是否锁定分类
    showSaveButton: false,  // 是否显示保存按钮
};

const mutations = {
    SET_EDIT_PRODUCT(state, product) {
        state.editProduct = product;
    },
    UPDATE_LOADING(state, value) {
        state.loading = value
    },
    // 打开图片选择
    OPEN_IMAGE_SELECT(state, payload) {
        state.imageSelect.show = true;
        state.imageSelect.field = payload.field || "";
        state.imageSelect._resolve = payload.resolve;
        state.imageSelect._reject = payload.reject;
    },
    // 关闭图片选择
    CLOSE_IMAGE_SELECT(state) {
        state.imageSelect.show = false;
        state.imageSelect.field = "";
        state.imageSelect._resolve = null;
        state.imageSelect._reject = null;
    },
    // 统一修改字段值， 格式 path = 'product.0.images' value = any
    UPDATE_FIELD_VALUE(state, { path, value, type = 'reset' }) {
        // console.log("UPDATE_FIELD_VALUE", path, value, type);
        const keys = path.split('.');

        let current = state;

        for (let i = 0; i < keys.length - 1; i++) {
            const key = keys[i];
            if (current?.[key]) {
                current = current[key];
            }
        }

        if (type == "reset") {
            current[keys[keys.length - 1]] = value;
        } else if (type == "add") {
            current[keys[keys.length - 1]].push(value);
        }
    },
};

const actions = {
    async getEditProduct({ dispatch, commit }, data) {
        try {
            if (!data?.id) {
                Message.error("商品ID不能为空");
                return false;
            }
            let res = await dispatch("getGoodsEdit", data.id);
            if (res.code == 1 && res.info?.source_json_data) {
                let tempData = {
                    id: data.id,
                    title: data.change_title,
                    classify_str: data.change_classify_str,
                    cid: 0,
                }
                tempData.cid = await dispatch("getCidByIdpathV2", data.change_idpath_v2);
                tempData.source_json_data = JSON.parse(res.info.source_json_data);
                if(res.info.attr_json){
                    tempData.attr_json = JSON.parse(res.info.attr_json);
                }else{
                    tempData.attr_json = {};
                }
                if(res.info.change_attribute_json){
                    tempData.change_attribute_json = JSON.parse(res.info.change_attribute_json);
                }else{
                    tempData.change_attribute_json = {};
                }

                if (!tempData.source_json_data?.white_background_image) {
                    tempData.source_json_data.white_background_image = [];
                }
                if (!tempData.source_json_data?.main_images_3_4) {
                    tempData.source_json_data.main_images_3_4 = [];
                }

                commit("SET_EDIT_PRODUCT", tempData);
                return true;
            } else {
                Message.error(res.msg || "获取商品信息失败");
            }
        } catch (e) {
            Message.error(e.message);
        }
        return false;
    },
    // 打开图片选择
    async openImageSelect({ commit, state }, field = "") {
        return new Promise((resolve, reject) => {
            commit('OPEN_IMAGE_SELECT', { resolve, reject, field });
        });
    },
    // 图片选择改变
    async imageSelectChange({ commit, state }, result) {
        if (state.imageSelect._resolve) state.imageSelect._resolve(result);
        commit("CLOSE_IMAGE_SELECT");
    },
    // 图片选择取消
    async closeImageSelect({ commit, state }) {
        if (state.imageSelect._reject) state.imageSelect._reject();
        commit("CLOSE_IMAGE_SELECT");
    },
    getGoodsEdit(context, id) {
        return Api.post("/admintooltaobaoaccount/goodsdetails", { id });
    },
    getCidByIdpathV2(context, change_idpath_v2) {
        if (change_idpath_v2) {
            const numbers = change_idpath_v2.match(/\d+/g); // 提取所有数字
            if (numbers?.length) {
                return numbers[numbers.length - 1]
            }
        }
        return 0;
    },
    async getProductSourceJsonData({ commit }, type_itemid) {
        const rs = await Call.invoke("productCacheFile.readSourceJson", type_itemid);
        if (rs?.code == 1) {
            return rs.data;
        }
        return null;
    },
    async setProductSourceJsonData({ commit }, { type_itemid, data }) {
        return Call.invoke("productCacheFile.writeSourceJson", type_itemid, data);
    },
    // 获取分类结构数据
    async getAttrJson({ commit }, cid_sys_shop_id) {
        const rs = await Call.invoke("productCacheFile.readAttrJson", cid_sys_shop_id);
        if (rs?.code == 1) {
            return rs.data;
        }
        return null;
    },
};

const getters = {};

export default {
    namespaced: true, // 推荐开启命名空间
    state,
    mutations,
    actions,
    getters,
};
